export default function PHP_money_format() {
  return (
    <div>
      <h1>PHP_money_format</h1>
    </div>
  );
}
